import { render, staticRenderFns } from "./ProfilMahasiswaMagister.vue?vue&type=template&id=2e7c6d1a"
import script from "./ProfilMahasiswaMagister.vue?vue&type=script&lang=js"
export * from "./ProfilMahasiswaMagister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports